// extracted by mini-css-extract-plugin
export default {"videoEmbed":"YoutubeVideoCell_videoEmbed__ztorn"};